
import Layout from '../../layout/default';
import DataTable from 'react-data-table-component';
import { useEffect, useState, useRef } from "react";
import { Link} from 'react-router-dom'
import { Navigate } from "react-router-dom";
import { Button,Breadcrumb } from "react-bootstrap";

import {Row, Col,Form} from 'react-bootstrap';

import Spinner from 'react-bootstrap/Spinner';

import exportFromJSON from 'export-from-json'
import DateRangePicker from '../../components/Form/DateRangePicker';
import { useApiClient } from '../../ApiService/useApiClient';

// import { jsPDF } from "jspdf";
// import autoTable from "jspdf-autotable";
// // //autoTable(jsPDF);
// // jsPDF.API.autoTable = autoTable;jsPDF.API.autoTable = autoTable;

const Export = ({ data }) => {
  const fileName = "user-data";

  const exportCSV = () => {
    const exportType = exportFromJSON.types.csv;
    exportFromJSON({ data, fileName, exportType });
  };

  const exportExcel = () => {
    const exportType = exportFromJSON.types.xls;
    exportFromJSON({ data, fileName, exportType });
  };

  // const exportPDF = () => {
  //   const doc = new jsPDF();
  //   const keys = Object.keys(data[0] || {});
  //   const rows = data.map(row => keys.map(k => row[k]));

  //   doc.text(fileName, 14, 10);
  //   doc.autoTable({
  //     startY: 20,
  //     head: [keys],
  //     body: rows,
  //     theme: 'striped',
  //     styles: { fontSize: 8 }
  //   });
  //   doc.save(`${fileName}.pdf`);
  // };

  // const handlePrint = () => {
  //   const doc = new jsPDF();
  //   const keys = Object.keys(data[0] || {});
  //   const rows = data.map(row => keys.map(k => row[k]));

  //   doc.text(fileName, 14, 10);
  //   doc.autoTable({
  //     startY: 20,
  //     head: [keys],
  //     body: rows,
  //     theme: 'grid',
  //     styles: { fontSize: 8 }
  //   });

  //   // Open the PDF in a new window for printing
  //   const pdfBlob = doc.output('blob');
  //   const blobUrl = URL.createObjectURL(pdfBlob);
  //   const printWindow = window.open(blobUrl);
  //   if (printWindow) {
  //     printWindow.onload = function () {
  //       printWindow.focus();
  //       printWindow.print();
  //     };
  //   }
  // };

  return (
    <div className="export-options d-flex align-items-center flex-wrap mb-3 gap-2">
      <div className="export-title small me-2">Export</div>
      <div className="btn-group">
        <Button variant="outline-light" onClick={exportCSV}>CSV</Button>
        <Button variant="outline-light" onClick={exportExcel}>Excel</Button>
        {/* <Button variant="outline-light" onClick={exportPDF}>PDF</Button>
        <Button variant="outline-light" onClick={handlePrint}>Print</Button> */}
      </div>
    </div>
  );
};


// export file component
// const Export = ({ data }) => {
//   const fileName = "user-data";

//   const exportCSV = () => {
//     const exportType = exportFromJSON.types.csv;
//     exportFromJSON({ data, fileName, exportType });
//   };

//   const exportExcel = () => {
//     const exportType = exportFromJSON.types.xls;
//     exportFromJSON({ data, fileName, exportType });
//   };

//   return (
//       <div className="export-options d-flex align-items-center me-2">
//           <div className="export-title small me-2">Export</div>
//           <div className="btn-group">
//               <Button variant="outline-light" onClick={() => exportCSV()}>
//                   CSV
//               </Button>
//               <Button variant="outline-light" onClick={() => exportExcel()}>
//                   Excel
//               </Button>
//           </div>
//       </div>
//   );
// };

const RunReport = ({ReportID,tableColumns, reportName}) => {
  
    const api = useApiClient();
    const[data, setdata] = useState(null);  
    const[error, setError] = useState(null); 
    const[processing, setProcessing] = useState(false); 
    const modalForm = useRef(null);  
  


    const RunReportClick = (event)=>{
    
      event.preventDefault();

      setProcessing(true);

      let StartDate = modalForm.current.querySelector('#start').value; 
      let endDate = modalForm.current.querySelector('#end').value; 

      let sUrlSuffix = "";
      if(StartDate != null && StartDate != "") sUrlSuffix = "/"+ StartDate;
      if(endDate != null && endDate != "") sUrlSuffix = sUrlSuffix + "/"+ endDate;

//console.log(sUrlSuffix);
            
      let baseURL = "HMCareReport/RunReport/"+ReportID+sUrlSuffix;

//console.log(baseURL);

        api.get(baseURL)        
          .then((Response)=>{
              setdata(Response.data);
              setProcessing(false);
             // console.log(data);

          }).catch(error => {
              setError(error);     
              //console.log({error})
              setProcessing(false);
          });

          


        }

   
        if (error) 
        {      
          if(error.message.indexOf("status code 401")){
            return <Navigate to="/auths/auth-login" />
          } else
          return "Error: ${error.message}";
        }
    
        if(!data && processing) return (
          <Layout title="Processing" content="container"><Spinner animation="border" variant="primary" /></Layout>
          );     
       

  return (
    <>
    <Layout title="Client Visits" content="container"> 
    
    <Breadcrumb className="breadcrumb-arrow">
      <Breadcrumb.Item><Link to={`/`}>Dashboard</Link></Breadcrumb.Item>      
      <Breadcrumb.Item active>Reports</Breadcrumb.Item>
    </Breadcrumb>    
   
    <>
    <h3>{reportName}</h3>

    <Row className="align-items-end mb-4" ref={modalForm} as={Form} onSubmit={RunReportClick}>
  <Col xs={12} md={6} lg={4}>
    <Form.Group controlId="dateRange">
      <Form.Label>Date Range</Form.Label>
      <DateRangePicker />
    </Form.Group>
  </Col>

  <Col xs={12} md={6} lg="auto" className="mt-3 mt-md-0">
    <Form.Group>
      <Form.Label className="d-none d-md-block">&nbsp;</Form.Label> {/* spacer for alignment */}
      <Button type="submit" variant="primary" disabled={processing} className="w-100">
        {!processing ? <>Run {reportName} Report</> : <Spinner animation="border" size="sm" />}
      </Button>
    </Form.Group>
  </Col>
</Row>



     {/* <Row className="g-gs">
      <Col md="6">   
        <Form ref={modalForm} onSubmit={RunReportClick}>
          <Form.Group className="form-group">           
          <DateRangePicker  />
          <Button type="submit" disabled={processing}>
              {!processing && <>Run {reportName} Report</>}
              {processing && <><Spinner animation="border" variant="primary" /></>}
          </Button>
          </Form.Group>
          </Form>
      </Col>    
     </Row>     */}
   
     </>  

{data &&
<>
    <Export data={data}/>
    <DataTable
            columns={tableColumns}
            data={data}
            className={"data-table-head-light table-responsive"}
            noDataComponent={<div className="p-2">There are no records found.</div>}
            sortIcon={
                <div className="data-table-sorter"></div>
            }           
            striped = {true}
            highlightOnHover={true}  
            pagination                  
    />
    </>
  }
    </Layout>   

    </>
)
}

export default RunReport